import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import { CustomButtonGroup } from '../../shared';
import Profile from './profile';
import CustomerSettingsPanel from './customerSettingsPanel';
import AssetsList from './assetsList';
import VendorIntegrations from './vendorIntegrations';
import AdminSettings from './adminSettings';
import { useSelector } from 'react-redux';
import FilterBar from './filterBar';

const settingsMapping = {
    'Profile': <Profile />,
    'Customer Settings Panel': <CustomerSettingsPanel />,
    'List of Assets': <AssetsList />,
    'Vendor Integrations': <VendorIntegrations />,
    'Admin Settings': <AdminSettings />,
};

function Settings() {
    const { userDetails: { is_admin } } = useSelector((state) => state.user);
    const ADMIN_SETTINGS = ['Profile', 'Customer Settings Panel', 'List of Assets', 'Vendor Integrations', 'Admin Settings'];
    const [selectedSetting, setSelectedSetting] = useState(ADMIN_SETTINGS[0]);

    const handleSettingChange = (setting) => {
            setSelectedSetting(setting);
    };

    return (
        <>
        <FilterBar/>
        <Grid container spacing={3}>
            {is_admin ? (
                <>
                    <Grid item xs={12}>
                        <Box>
                            <CustomButtonGroup
                                data={ADMIN_SETTINGS}
                                selected={selectedSetting}
                                handleClick={(setting) =>
                                    handleSettingChange(setting)
                                }
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        {settingsMapping[selectedSetting]}
                    </Grid>
                </>
            ) : (
                <Grid item xs={12}>
                    <Profile />
                </Grid>
            )}
        </Grid>
        </>
    );
}

export default Settings;
